<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({
        fromAdmin: true,
        _start: 0,
        _limit: -1,
        enrollmentFlag: 'reserve',
      })
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          const res = {
            'Mã hồ sơ': cv.code,
            'Cơ sở': cv.department,
            'Tên thí sinh': get(cv, 'name'),
            'Số điện thoại đăng ký': cv.parentUsername,
            Email: cv.parentEmail,
            'Điểm NN': get(cv, 'ltvExamResult.examLanguage'),
            'Điểm TD': get(cv, 'ltvExamResult.examMathMark'),
            'Tổng điểm': get(cv, 'ltvExamResult.examTotal'),
            'Trạng thái': cv.reserveRegisterState === 'success' ? 'Đã đăng ký' : 'Chưa đăng ký',
          }
          return res
        }),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ho-so-k6-dk-ds-cho.xlsx')
      this.$loading.active = false
    },
  },
}
</script>
